import { useEffect } from "react";
import "./Header.css";

function Header() {
  useEffect(() => {
    const scriptWidget = document.createElement("script");
    scriptWidget.src = "//embeds.iubenda.com/widgets/94b37d52-0425-4231-ba20-562ea7a50385.js";
    scriptWidget.type = "text/javascript";
    scriptWidget.async = true;

    const container = document.getElementById("iubenda-widget-container");
    if (container) {
      container.appendChild(scriptWidget);
    }
  }, []);

  return (
    <header>
      <div className="header" id="Home">
        <h1 className="sr-only">Positanonboard - Welcome</h1> {/* Per SEO e screen reader */}
        <h3>WELCOME TO</h3>
        <img
          className="logo"
          src="/Assets/headerLogo2.svg"
          alt="Logo Positanonboard"
        />
      </div>
      <div className="privacyWidget" id="iubenda-widget-container" aria-label="Informativa sulla privacy"></div>
    </header>
  );
}

export default Header;
